import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';

import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';

import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MemberProviderNetworkService } from '@sondermind/data-access/provider-facing/provider-profile';

import { SondermindCommonModule } from '@sondermind/features/modules/common';
import { SondermindProfileModule } from '@sondermind/features/modules/profile';
import { NavbarModule } from '@sondermind/features/navbar';
import { TherapistProfileModule } from '@sondermind/features/therapist-profile';

import { IrisButtonModule } from '@sondermind/iris/button';
import { IrisCardModule } from '@sondermind/iris/card';
import { IrisCheckboxModule } from '@sondermind/iris/checkbox';
import { IrisDropdownModule } from '@sondermind/iris/dropdown';
import { IrisFormFieldModule } from '@sondermind/iris/form-field';
import { IrisIconComponent } from '@sondermind/iris/icon';
import { IrisRadioGroupModule } from '@sondermind/iris/radio-group';
import { IrisTextAreaModule } from '@sondermind/iris/text-area';
import { IrisTextInputModule } from '@sondermind/iris/text-input';

import { TooltipModule } from '@sondermind/features/tooltip';
import {
  PendingChangesModalComponent,
  ProfileAboutYouPage,
  ProfileBioPage,
  ProfileFocusPage,
  ProfileSpecialtySelectorComponent,
  ProfileSubmitComponent,
  ProviderNetworkListComponent
} from '@sondermind/features/provider-facing/provider-profile';

import { IrisModalModule, IrisModalRef } from '@sondermind/iris/modal';
import { IrisTabModule } from '@sondermind/iris/tab';
import { LocalizedDatePipe } from '@sondermind/utilities/time-and-date';
import { CoreModule } from '@sondermind/core/core.module';
import { DesignModule } from '@sondermind/core/design.module';

import { PotentialClientsViewCardComponent } from '@sondermind/member/components/potential-clients-view-card/potential-clients-view-card.component';
import { ProfileLicenseInsurancePage } from '@sondermind/member/pages/profile-license-insurance/profile-license-insurance.component';
import { SortProviderNetworkListPipe } from '@sondermind/member/pipes/sort-provider-network-list.pipe';

import { ProfileApproachesPage } from '../../pages/profile-approaches/profile-approaches.component';
import { ProfileIdentityPage } from '../../pages/profile-identity/profile-identity.component';
import { ProfileSpecialtiesPage } from '../../pages/profile-specialties/profile-specialties.component';

import { ProfileAppComponent } from './profile-app.component';
import { ProfileRoutingModule } from './profile-routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ProfileRoutingModule,
    NgxMaskDirective,
    MatIconModule,
    MatFormFieldModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatTabsModule,
    MatTooltipModule,
    SondermindCommonModule,
    SondermindProfileModule,
    DesignModule,
    CoreModule,
    NavbarModule,
    IrisButtonModule,
    IrisCardModule,
    IrisIconComponent,
    IrisRadioGroupModule,
    IrisFormFieldModule,
    IrisTextInputModule,
    IrisCheckboxModule,
    IrisDropdownModule,
    IrisTextAreaModule,
    TherapistProfileModule,
    IrisTabModule,
    IrisModalModule,
    TooltipModule,
    LocalizedDatePipe,
  ],
  declarations: [
    PendingChangesModalComponent,
    PotentialClientsViewCardComponent,
    ProfileAppComponent,
    ProfileSubmitComponent,
    ProfileSpecialtySelectorComponent,
    ProviderNetworkListComponent,
    ProfileFocusPage,
    ProfileBioPage,
    ProfileAboutYouPage,
    ProfileIdentityPage,
    ProfileApproachesPage,
    ProfileSpecialtiesPage,
    ProfileLicenseInsurancePage,
    SortProviderNetworkListPipe
  ],
  providers: [
    MemberProviderNetworkService,
    {
      provide: MAT_DIALOG_DATA,
      useValue: {}
    },
    { provide: IrisModalRef, useValue: {} },
    provideNgxMask()
  ]
})
export class ProfileModule { }
